






import { Component, Prop, Vue } from 'vue-property-decorator';
import { IDisclaimerInfo } from '../Scripts/Discaimer';

@Component({
	components: {
	}
})
export default class DisclaimerVue extends Vue {
	@Prop() public info!: IDisclaimerInfo;

	get autoShow (): boolean {
		return this.info.enabled && !this.$store.state.dismissedDisclaimer;
	}

	private close () {
		this.$store.commit('dismissDisclaimer', true);
	}
}
